(() => {
  const filtersBtn = document.querySelector('.filters-btn');
  const facetsMain = document.querySelector('.facets__main');
  const closeBtns = document.querySelectorAll('.close-icon');
  const shopifyHeader = document.querySelector('.shopify-section-header');
  const announceBar = document.querySelector('.section-announcement');

  if (!filtersBtn || !facetsMain) return;

  const toggleZIndex = (isOpen) => {
    const value = isOpen ? '2' : '20';
    announceBar && (announceBar.style.zIndex = value);
    shopifyHeader && (shopifyHeader.style.zIndex = value);
  };

  const openMenu = () => {
    facetsMain.classList.add('active');
    document.body.classList.add('no-scroll');
    toggleZIndex(true);
  };

  const closeMenu = () => {
    facetsMain.classList.remove('active');
    document.body.classList.remove('no-scroll');
    toggleZIndex(false);
  };

  filtersBtn.addEventListener('click', openMenu);

  closeBtns.forEach(btn => btn.addEventListener('click', closeMenu));

  document.addEventListener('click', (e) => {
    if (
      facetsMain.classList.contains('active') &&
      !facetsMain.contains(e.target) &&
      !filtersBtn.contains(e.target)
    ) {
      closeMenu();
    }
  });

  facetsMain.addEventListener('click', (e) => {
    if (e.target === facetsMain) closeMenu();
  });
})();
